import PropTypes from "prop-types"
import PerformanceTopFactors from "modules/performance-top-factors"
import { percentageFormatter } from "helpers/formatters/numbers"
import { DATE } from "helpers/shapes"

function OverviewPerformanceDetails({ factorsPerformance, performanceDetails, startDate, endDate, firstDate, modelId }) {
  if (performanceDetails) {
    return <PerformanceTopFactors
      factorsPerformance={factorsPerformance}
      factors={performanceDetails}
      valueFormatter={percentageFormatter}
      startDate={firstDate || startDate}
      endDate={endDate}
      modelId={modelId}
    />
  } else {
    return <h5>Data currently not available</h5>
  }
}

OverviewPerformanceDetails.propTypes = {
  modelId: PropTypes.string.isRequired,
  factorsPerformance: PropTypes.object,
  performanceDetails: PropTypes.object,
  startDate: DATE.isRequired,
  firstDate: DATE,
  endDate: DATE.isRequired,
}

export default OverviewPerformanceDetails
